"use client";

import React, { useEffect, useRef, useState } from "react";
import Linkify from "linkify-react";

import cx from "@/utils/cx";

interface LinkifyProps
  extends React.ComponentProps<typeof Linkify>,
    React.HTMLAttributes<HTMLElement> {
  baseUrl?: string;
  enableReadMore?: boolean;
  clamp?: number;
  setInnerHtml?: boolean;
}

const LinkifyText: React.FC<LinkifyProps> = ({
  children,
  className,
  enableReadMore,
  clamp = 2,
  setInnerHtml = false,
  ...rest
}) => {
  const [hasMoreOpen, setHasMoreOpen] = useState<boolean | null>(null);
  const ref = useRef<HTMLParagraphElement>(null);

  useEffect(() => {
    const element = ref.current;

    if (!element) return;

    if (
      element.offsetHeight < element.scrollHeight ||
      element.offsetWidth < element.scrollWidth
    ) {
      setHasMoreOpen(false);
    } else {
      setHasMoreOpen(null);
    }
  }, [children, enableReadMore]);

  return (
    <Linkify
      options={{
        target: "_blank",
      }}
      {...rest}
    >
      {typeof children === "string" ? (
        <div>
          <div
            ref={ref}
            style={{
              // @ts-ignore
              "--line-clamp": clamp,
              "--tw-prose-bullets": "black",
            }}
            className={cx(
              "prose prose-neutral [&>a]:text-blue-600 [&>p]:my-[0.5em] [&_li_p]:my-[0.2em] [&_ul]:my-0 [&_li]:my-0 [&>a]:no-underline [&>a]:font-semibold overflow-hidden whitespace-pre-line",
              {
                "line-clamp-[var(--line-clamp)]":
                  !hasMoreOpen && enableReadMore,
                "line-clamp-none": hasMoreOpen && enableReadMore,
              },
              className
            )}
            dangerouslySetInnerHTML={
              setInnerHtml ? { __html: children } : undefined
            }
          >
            {!setInnerHtml ? children : null}
          </div>
          {hasMoreOpen !== null && (
            <button
              className="text-primary text-sm font-semibold"
              onClick={() => setHasMoreOpen(!hasMoreOpen)}
            >
              {hasMoreOpen ? "Show less" : "Show more"}
            </button>
          )}
        </div>
      ) : (
        children
      )}
    </Linkify>
  );
};

export default LinkifyText;
